import { fetch, buildUrl } from 'domain/Api';
import { ApiCall, PrivilegeChecker } from 'omni-common-ui';
import Privileges from 'domain/Privileges';
import { List } from 'immutable';
import { actions as studentReportSummariesAction } from 'data/ProgressReports/StudentReportSummaries';
import { getProgressReportIdBySessionId } from 'data/ProgressReports/accessors';

export const FETCH_PAPERBASE_HOMEWORK_REQUEST = 'FETCH_PAPERBASE_HOMEWORK_REQUEST';
export const FETCH_PAPERBASE_HOMEWORK_SUCCESS = 'FETCH_PAPERBASE_HOMEWORK_SUCCESS';
export const FETCH_PAPERBASE_HOMEWORK_FAILURE = 'FETCH_PAPERBASE_HOMEWORK_FAILURE';
export const FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST = 'FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST';
export const FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS = 'FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS';
export const FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE = 'FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE';
export const SUBMIT_PAPERBASE_HOMEWORK_REQUEST = 'SUBMIT_PAPERBASE_HOMEWORK_REQUEST';
export const SUBMIT_PAPERBASE_HOMEWORK_SUCCESS = 'SUBMIT_PAPERBASE_HOMEWORK_SUCCESS';
export const SUBMIT_PAPERBASE_HOMEWORK_FAILURE = 'SUBMIT_PAPERBASE_HOMEWORK_FAILURE';

const buildFetchPaperBasedHomeworkUrl = (id) => buildUrl(`/sessions/${id}/student-homework-result`);

export function fetchPaperBasedHomeworkIfNeeded(id) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state,
        { method: 'GET', url: buildFetchPaperBasedHomeworkUrl(id) })) {
      return false;
    }

    return dispatch(fetchPaperBasedHomework(id));
  };
}

export function fetchPaperBasedHomework(id) {
  return (dispatch) => {
    const url = buildFetchPaperBasedHomeworkUrl(id);
    const method = 'GET';

    return dispatch(fetchPaperBasedHomeworkRequest()).payload
      .then((response) => dispatch(fetchPaperBasedHomeworkSuccess(response)))
      .catch((error) => dispatch(fetchPaperBasedHomeworkFailure(error)));

    function fetchPaperBasedHomeworkRequest() {
      return ApiCall.createAction({
        type: FETCH_PAPERBASE_HOMEWORK_REQUEST,
        payload: fetch(url),
        url,
        method,
        id,
      });
    }

    function fetchPaperBasedHomeworkSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_PAPERBASE_HOMEWORK_SUCCESS,
        payload: response,
        url,
        method,
        id,
      });
    }

    function fetchPaperBasedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: FETCH_PAPERBASE_HOMEWORK_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}

const buildFetchGroupPaperBasedHomeworkUrl = (id) => buildUrl(`/groups/${id}/student-homework-result`);

export function fetchGroupPaperBasedHomeworkIfNeeded(id) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state,
        { method: 'GET', url: buildFetchGroupPaperBasedHomeworkUrl(id) })) {
      return false;
    }

    return dispatch(fetchGroupPaperBasedHomework(id));
  };
}

export function fetchGroupPaperBasedHomework(id) {
  return (dispatch) => {
    const url = buildFetchGroupPaperBasedHomeworkUrl(id);
    const method = 'GET';

    return dispatch(fetchGroupPaperBasedHomeworkRequest()).payload
      .then((response) => dispatch(fetchGroupPaperBasedHomeworkSuccess(response)))
      .catch((error) => dispatch(fetchGroupPaperBasedHomeworkFailure(error)));

    function fetchGroupPaperBasedHomeworkRequest() {
      return ApiCall.createAction({
        type: FETCH_GROUP_PAPERBASE_HOMEWORK_REQUEST,
        payload: fetch(url),
        url,
        method,
      });
    }

    function fetchGroupPaperBasedHomeworkSuccess(response) {
      return ApiCall.createAction({
        type: FETCH_GROUP_PAPERBASE_HOMEWORK_SUCCESS,
        payload: response,
        url,
        method,
      });
    }

    function fetchGroupPaperBasedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: FETCH_GROUP_PAPERBASE_HOMEWORK_FAILURE,
        error,
        url,
        method,
      });
    }
  };
}

export function submitMarkPaperBasedHomework(id, paperBasedList) {
  let homework = paperBasedList;
  if (List.isList(homework)) {
    homework = homework.toArray();
  }
  homework = homework.map((paperBased) => ({
    lessonNumber: Number(paperBased.lessonNumber),
    sessionId: Number(id),
    unitId: Number(paperBased.unitId),
    studentPaperBasedHomeworks: paperBased.studentPaperBasedHomeworks.reduce((arr, hw) => [...arr, {
      homeworkStatus: hw.homeworkStatus,
      studentId: hw.studentId,
    }], []),
    studentTutorialHomeworks: paperBased.studentTutorialHomeworks.reduce((arr, hw) => [...arr, {
      homeworkStatus: hw.homeworkStatus,
      studentId: hw.studentId,
    }], []),
  }));
  return (dispatch, getState) => {
    const url = buildUrl(`/sessions/${id}/student-homework-result`);
    const method = 'PUT';
    const progressReportIds = getProgressReportIdBySessionId(getState(), id);
    return dispatch(submitMarkPaperBasedHomeworkRequest()).payload
      .then((response) => dispatch(submitMarkPaperBasedHomeworkSuccess(response)))
      .catch((error) => dispatch(submitMarkPaperBasedHomeworkFailure(error)))
      .then(() => dispatch(fetchPaperBasedHomework(id)))
      .then(() => {
        if (PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressReport.View)) {
          progressReportIds.forEach((progressReportId) =>
            dispatch(studentReportSummariesAction.fetchStudentReportSummaries(progressReportId)));
        }
      });

    function submitMarkPaperBasedHomeworkRequest() {
      const request = fetch(url,
        {
          method,
          body: JSON.stringify(homework),
        }
      );
      return ApiCall.createAction({
        type: SUBMIT_PAPERBASE_HOMEWORK_REQUEST,
        payload: request,
        url,
        method,
        id,
        homework,
      });
    }

    function submitMarkPaperBasedHomeworkSuccess(response) {
      return ApiCall.createAction({
        type: SUBMIT_PAPERBASE_HOMEWORK_SUCCESS,
        payload: response,
        url,
        method,
      });
    }

    function submitMarkPaperBasedHomeworkFailure(error) {
      return ApiCall.createAction({
        type: SUBMIT_PAPERBASE_HOMEWORK_FAILURE,
        url,
        method,
        error,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/PaperBasedHomework/actions.js